import { ADD_DATA, ADD_DATA_MULTI, REMOVE_DATA_ARRAY_ITEM, REMOVE_DATA_KEY, RESET_DATA, RESET_DATA_KEY, SET_DATA, SET_DATA_MULTI } from 'services/redux/action-types'
import _ from 'lodash';
import { dataConstants } from "services/redux/data/constants";
import { CalendarViewModes } from 'utils/constants/calendar-modes-constants'

const initialState = {
	[ dataConstants.APP_IS_FOCUSED ]: true,
	[ dataConstants.APP_FULL_WIDTH ]: false,
	
	[ dataConstants.SERVER_TIMEZONE ]: 'Europe/Amsterdam',
	[ dataConstants.SERVER_TIMEZONE_OFFSET ]: 0,
	
	[ dataConstants.INITIAL_URL ]: null,
	[ dataConstants.APP_MESSAGES ]: {},
	[ dataConstants.SETTINGS ]: {},
	[ dataConstants.FILTERS ]: {},
	[ dataConstants.EMPLOYEE ]: {},
	[ dataConstants.BOOKINGS ]: {},
	[ dataConstants.BOOKINGS_PAST ]: {},
	[ dataConstants.LANGUAGES ]: {},
	//
	[ dataConstants.BUILDINGS ]: {},
	[ dataConstants.BUILDING_CAPACITIES ]: {},
	[ dataConstants.BUILDING_PARKING_SPACES ]: {},
	[ dataConstants.FLOORS ]: {},
	[ dataConstants.ROOMS ]: {},
	[ dataConstants.TABLES ]: {},
	[ dataConstants.DEPARTMENTS ]: {},
	[ dataConstants.TEAMS ]: {},
	
	[ dataConstants.TIMESLOT_KINDS ]: {},
	[ dataConstants.TIMESLOT_GROUPS ]: {},
	
	[ dataConstants.EMPLOYEES ]: {},
	
	[ dataConstants.EMPLOYEES_DETAILED ]: {},
	[ dataConstants.EMPLOYEES_BOOKINGS ]: {},
	
	[ dataConstants.EMPLOYEES_ERO ]: {},
	[ dataConstants.EMPLOYEES_ERO_LOADED ]: false,
	[ dataConstants.EMPLOYEES_CONFIDANTS ]: {},
	[ dataConstants.EMPLOYEES_CONFIDANTS_LOADED ]: false,
	
	//
	[ dataConstants.MEETING_ROOMS ]: {},
	
	[ dataConstants.FAVOURITES ] : {},
	[ dataConstants.BUILDING_FAVOURITES ] : {},
	[ dataConstants.FLOOR_FAVOURITES ] : {},
	[ dataConstants.ROOM_FAVOURITES ] : {},
	
	//
	[ dataConstants.PARKING_STATUSES ] : [],
	
	//
	[ dataConstants.INVITATIONS_SENT ]: {},
	[ dataConstants.INVITATIONS_SENT_COUNT ]: 0,
	//
	[ dataConstants.COWORKERS ]: [],
	[ dataConstants.EMPLOYEE_TRANSPORTS ]: {},
	[ dataConstants.TIMESLOTS_OCCUPIED ]: {},
	[ dataConstants.TIMESLOTS_OCCUPIED_MY_FAVOURITES ]: {},
	[ dataConstants.LUNCH_OPTIONS ]: {},
	
	// Notifications
	[ dataConstants.MESSAGES ]: {},
	[ dataConstants.MESSAGE_COUNT ]: 0,
	[ dataConstants.LINKS ]: {},
	
	// Calendar
	[ dataConstants.CALENDAR_VIEW_MODE_BOOKINGS ] : CalendarViewModes.WEEK,
	
	// Events
	[ dataConstants.EVENTS ]: {},
	
	// Others
	[ dataConstants.FETCHES ]: {},
	[ dataConstants.IN_MANAGEMENT ]: false,
	
	[ dataConstants.ALERT ]: null,
};

export default function data( state = initialState, action ) {
	
	const initialValue = initialState[ action.key ];
	const initialDefaultValue = _.isArray( initialValue ) ? [] : {};
	
	switch (action.type) {
		case SET_DATA:
			let newValue = action.payload;
			
			// Is it an object? Then 'copy' it
			if( _.isObject( initialValue ) ) {
				if( !_.isArray( initialValue ) ) {
					newValue = {
						...action.payload
					};
				} else {
					newValue = [
						...action.payload
					];
				}
			}
			
			return {
				...state,
				[action.key]: newValue
			};
			
		case SET_DATA_MULTI:
			return {
				...state,
				...action.payload
			};
		
		case ADD_DATA:
			
			// When the payload is empty do not merge them
			if( _.isEmpty( action.payload ) ) {
				return state;
			}
			
			const currentData = _.get( state, action.key, initialDefaultValue );
			
			// Reset payload keys first when set
			if( action.payload_reset_by_keys ) {
				_.forEach( _.keys( action.payload ), ( payloadKey ) => {
					delete currentData[ payloadKey ]
				})
			}
			
			return {
				...state,
				[ action.key ]: {
					...currentData,
					...action.payload
				}
			}
		
		case ADD_DATA_MULTI:
			let didUpdate = false;
			
			// Combine the old state with the new values
			_.forEach( action.payload, ( values, key ) => {
				
				if( !_.isEmpty( values ) ) {
					didUpdate = true;
					
					state[ key ] = {
						..._.get( state, key, initialDefaultValue ),
						...values
					}
				}
			});
			
			// Modify when updated
			if( didUpdate ) {
				state = {
					...state
				};
			}
			
			return state;
			
		case RESET_DATA_KEY:
			return {
				...state,
				...{
					[action.key]: {
						..._.get( state, action.key, initialDefaultValue ),
						[ action.payload ]: action.value
					}
				}
			}
			
		case REMOVE_DATA_KEY:
			const data = _.get( state, action.key, initialDefaultValue );
			delete data[ action.payload ];
			
			return {
				...state,
				...{
					[action.key]: {
						...data
					}
				}
			}
			
		case REMOVE_DATA_ARRAY_ITEM:
			const array = _.pull( _.get( state, action.key, initialDefaultValue ), action.payload );
			
			return {
				...state,
				...{
					[action.key]: array
				}
			}

		case RESET_DATA:
			return initialState;
			
		default:
			// Nothing
	}
	
	return state;
}
